import React, { Fragment, useState } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import qr from "../../Assets/qrcode.png"

const AuthenticatorModal = ({ auth, setAuth }) => {
    const [data, setData] = useState(false)
    return (
        <div>
            <Transition.Root show={auth} as={Fragment}>
                <Dialog as="div" className="relative z-10" onClose={setAuth}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-[#c1c9d2b3]" />
                    </Transition.Child>

                    <div className="fixed inset-0 z-10 overflow-y-auto">
                        <div className="flex min-h-full justify-center p-4 text-center items-center sm:p-0">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                enterTo="opacity-100 translate-y-0 sm:scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            >
                                <Dialog.Panel className="relative transform overflow-visible rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 w-full max-w-md">
                                    <div>
                                        <div className="font-semibold p-[16px_20px] border-b-[1px] border-[#ebeef1] text-base text-gray-900">Use an authenticator app</div>
                                        <div className="sm:p-[16px_20px] p-[16px_20px] border-b-[1px] border-[#ebeef1] bg-[#f6f8fa]">
                                            <p className='text-[#414552] mt-2 text-sm'>Download the free <span className='font-semibold text-[#625afa]'>Google Authenticator</span> app, add a new account, then scan this QR code to set up your account.</p>
                                            {data ?
                                                <div className='flex mt-5 p-[4px_8px] rounded-[6px] w-max mx-auto text-[24px] text-[#414552] justify-center-center shadow-[0_0_0_1px_rgb(235,238,241)] font-medium'>
                                                    evvhzqdeqfwwdflgepkoq3wk
                                                </div>
                                                :
                                                <div className='flex mt-5 justify-center-center'>
                                                    <img src={qr} className='h-[164px] w-[164px] mx-auto' alt="qr" />
                                                </div>
                                            }
                                            <div className='flex justify-center mt-3'>
                                                <button onClick={() => setData(!data)} className='text-sm font-medium text-[#625afa]'>
                                                    {data ? "Scan QR code instead" : "Enter code manually"}
                                                </button>
                                            </div>
                                        </div>
                                        <div className="font-semibold p-[16px_20px] flex justify-end text-base text-gray-900 gap-2">
                                            <button onClick={() => setAuth(false)} className="h-[30px] rounded-[6px] input_focus_shadow text-[14px] font-semibold p-[0_8px]">Cancel</button>
                                            <button className="border-[2px] h-[30px] rounded-[6px] border-[#625afa] text-white bg-[#625afa] text-[14px] font-semibold p-[0_8px]">Continue</button>
                                        </div>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition.Root>
        </div>
    )
}

export default AuthenticatorModal